import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { AuthProvider } from "./contexts/AuthContext";
import { useContentProtection } from "./hooks/useContentProtection";

function ContentProtectionWrapper({ children }: { children: React.ReactNode }) {
  useContentProtection();
  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ContentProtectionWrapper>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ContentProtectionWrapper>
    </BrowserRouter>
  );
}

export default App;
